module.exports = __webpack_public_path__ + "static/img/logo2-sfr.17d794f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo2-sfr.png
// module id = K+XI
// module chunks = 1